import useRecordImage from '$tablet-app/src/app/images/hooks/useRecordImage';
import { RecordWithImageFields } from '$tablet-app/src/app/images/types';
import React, { FC } from 'react';
import { Image, ImageProps } from 'react-native-elements/dist/image/Image';

interface RecordImageProps extends Partial<ImageProps> {
  record?: RecordWithImageFields;

  fallback?: any;

  edits?: any;
}

const RecordImage: FC<RecordImageProps> = ({
  record,
  fallback,
  edits,
  ...props
}) => {
  const { uri } = useRecordImage({ record, edits });

  return uri ? (
    <Image {...props} source={typeof uri === 'string' ? { uri } : uri} />
  ) : (
    fallback || null
  );
};

export default RecordImage;
